"use client";
import { cn } from "@layer/utils/cn";
import { motion } from "motion/react";
import type { SVGProps } from "react";

type MPLogoProps = SVGProps<SVGSVGElement> & {
	animateLogo?: boolean;
};

const MPLogo = ({ className, animateLogo }: MPLogoProps) => {
	return (
		<motion.svg
			width="100"
			height="100"
			viewBox="0 0 100 100"
			className={cn(className, "fill-black dark:fill-white")}
			xmlns="http://www.w3.org/2000/svg"
			animate={animateLogo ? "animate" : "initial"}
			initial="initial"
			variants={{
				initial: {
					rotate: 0,
				},
				animate: {
					rotate: -45,
					transition: {
						// Waits for circle animation to complete
						duration: 0.3,
						ease: "easeOut",
					},
				},
			}}
		>
			<motion.circle
				className="fill-info-solid"
				cx="50"
				cy="50"
				r="50"
				variants={{
					initial: {
						opacity: 0,
						scale: 0,
						rotate: -180,
					},
					animate: {
						opacity: 1,
						scale: 1,
						rotate: 0,
						transition: {
							delay: 0.3,
							duration: 0.5,
							ease: "easeOut",
						},
					},
				}}
			/>
			<motion.path d="M82.5269 82.5269C84.089 84.089 84.0987 86.6355 82.4168 88.0678C75.9392 93.5839 68.1422 97.3708 59.7545 99.0393C50.0555 100.969 40.0021 99.9784 30.8658 96.194C21.7295 92.4096 13.9206 86.001 8.42652 77.7785C2.93245 69.5561 6.09056e-07 59.8891 0 50C-6.09056e-07 40.1109 2.93245 30.4439 8.42652 22.2215C13.9206 13.999 21.7295 7.59041 30.8658 3.80603C40.0021 0.0216429 50.0555 -0.968525 59.7545 0.960735C68.1422 2.62915 75.9392 6.41613 82.4167 11.9322C84.0987 13.3645 84.089 15.911 82.5269 17.4731L52.8284 47.1716C51.2663 48.7337 51.2663 51.2663 52.8284 52.8284L82.5269 82.5269Z" />
		</motion.svg>
	);
};

export default MPLogo;
